import { Col, Form, Input, Modal, ModalProps, Row, Select } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import {
  RecipeNormalDoseCategories,
  RecipeNormalDoseTypeName,
  RecipeNormalFrequencyCategories,
  RecipeNormalFrequencyName,
  RecipeNormalUsemethodCategories,
  RecipeNormalUsemethodName,
  RecipePreparationPasteCategories,
  RecipePreparationPasteName,
  RecipePreparationPasteNumCategories,
  RecipePreparationPasteNumName,
  RecipeTabletManufacturingCategories,
  RecipeTabletManufacturingName,
  RecipeTabletManufacturingNumCategories,
  RecipeTabletManufacturingNumName,
} from '../../../models/decoctingSettingModal'
import { DefaultUseMethod } from '../../../models/recipeusemethod'
import { source } from '../../../models/registration'
import { ThemeContext } from '../../../theme/ThemeContext'
import styles from './RecipeListEditor.module.css'
interface UseMethodModalProps {
  value?: string[]
  onChange: (values: string[], formValue?: any) => void
  elseRecipeUseMethod?: any
}

const K1 = ['水煎煮', '泡酒', '打粉', '制丸', '制膏', '装胶囊', '中药粉']

const K2 = ['内服', '外用', '泡脚', '代茶饮', '穴位贴敷']

const K3 = ['温服', '凉服', '温热服', '热服', '顿服', '慢服', '兑水冲服']

const K4 = ['饭前服', '饭后服', '空腹服','睡前服', '热服捂汗', '无服用要求']

export const UseMethodModal = ({
  value = DefaultUseMethod,
  onChange,
  elseRecipeUseMethod,
  ...others
}: UseMethodModalProps & ModalProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const [selectedValues, setSelectedValues] = useState(value)
  const [fyyqDisplay, setFyyqDisplay] = useState('flex')

  const [form] = Form.useForm()

  const recipeNormalFrequency = ((value[0] == '制膏' || value[0] == '制丸') ? undefined : elseRecipeUseMethod?.recipeNormalFrequency) || localStorage.getItem(
    'recipeNormalFrequency'
  )
  const recipeNormalUsemethod = ((value[0] == '制膏' || value[0] == '制丸') ? undefined : elseRecipeUseMethod?.recipeNormalUsemethod) || localStorage.getItem(
    'recipeNormalUsemethod'
  )
  const recipeNormalDose = elseRecipeUseMethod?.recipeNormalDose || localStorage.getItem('recipeNormalDose')
  
  //制膏
  const recipeTabletManufacturingNum = (value[0] == '制膏' && elseRecipeUseMethod?.recipeNormalFrequency) || localStorage.getItem(
    'recipeTabletManufacturingNum'
  )
  const recipePreparationPaste = (value[0] == '制膏' && elseRecipeUseMethod?.recipeNormalUsemethod) || localStorage.getItem(
    'recipePreparationPaste'
  )
  //制丸
  const recipeTabletManufacturingNumZW = (value[0] == '制丸' && elseRecipeUseMethod?.recipeNormalFrequency) || localStorage.getItem(
    'recipeTabletManufacturingNumZW'
  )
  const recipePreparationPasteZW = (value[0] == '制丸' && elseRecipeUseMethod?.recipeNormalUsemethod) || localStorage.getItem(
    'recipePreparationPasteZW'
  )

  const row = {
    gutter: 10,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
    },
  }

  const col = {
    span: 4,
    style: {
      marginBottom: 10,
      lineHeight: '2rem',
      textAlign: 'center',
      fontSize: '1rem',
    } as React.CSSProperties,
  }

  const firstColumnLayout = {
    labelCol: {
      flex: '0 0 7rem',
    },
  }

  const btn = (selected: boolean) => ({
    style: {
      backgroundColor: selected ? theme.c1 : undefined,
      boxSize: 'border',
      border: selected ? undefined : `solid 1px ${theme.wbd}`,
      borderRadius: 2,
      color: selected ? theme.tt : theme.tc1,
      cursor: 'pointer',
    },
  })

  const setFormValues = (v: string) => {
    //判断制膏 两个下拉框值
    const flagOne = recipeTabletManufacturingNum && recipeTabletManufacturingNum != 'null' && recipeTabletManufacturingNum != 'undefined'
    const flagTwo = recipePreparationPaste && recipePreparationPaste != 'null' && recipePreparationPaste != 'undefined'
    
    //判断制丸 两个下拉框值
    const flagOneZW = recipeTabletManufacturingNumZW && recipeTabletManufacturingNumZW != 'null' && recipeTabletManufacturingNumZW != 'undefined'
    const flagTwoZW = recipePreparationPasteZW && recipePreparationPasteZW != 'null' && recipePreparationPasteZW != 'undefined'

    form.setFieldsValue({
      recipeNormalFrequency: v == '制膏' ? 
       (flagOne ? recipeTabletManufacturingNum : '每日两次')
       : v == '制丸' ?
       (flagOneZW ? recipeTabletManufacturingNumZW : '每日两次')
        : (recipeNormalFrequency &&
          recipeNormalFrequency != 'null' &&
          recipeNormalFrequency != 'undefined'
        ? recipeNormalFrequency
        : '每日一帖'),
      recipeNormalUsemethod:  v == '制膏' ?
        (flagTwo ? recipePreparationPaste : '每次20g')
        : v == '制丸' ?
        (flagTwoZW ? recipePreparationPasteZW : '每次10g')
        : (recipeNormalUsemethod &&
          recipeNormalUsemethod != 'null' &&
          recipeNormalUsemethod != 'undefined'
        ? recipeNormalUsemethod
        : '每帖一次'),
      recipeNormalDose: v == '制膏' || v == '制丸' ? '' 
        : recipeNormalDose &&
          recipeNormalDose != 'null' &&
          recipeNormalDose != 'undefined'
        ? recipeNormalDose
        : '每次100ml',
      remark: elseRecipeUseMethod?.remark || '',
    })
  }

  useEffect(() => {
    setSelectedValues(value?.length ? value : DefaultUseMethod)
    if (value[1] && value[1] === '外用') {
      setFyyqDisplay('none')
    } else {
      setFyyqDisplay('flex')
    }
  }, [value])

  useEffect(() => {
    if (fyyqDisplay == 'none') {
      const filterList = selectedValues.filter(
        (v) =>
          ![
            '温服',
            '凉服',
            '顿服',
            '慢服',
            '饭前服',
            '饭后服',
            '空腹服',
            '无服用要求',
          ].includes(v)
      )
      if (selectedValues?.length != filterList.length) {
        setSelectedValues(filterList)
      }
    }
  }, [selectedValues, fyyqDisplay])

  useEffect(() => {
    if (!others.visible) {
      form.resetFields()
      setSelectedValues(value)
      if (value[1] && value[1] === '外用') {
        setFyyqDisplay('none')
      } else {
        setFyyqDisplay('flex')
      }
    } else {
      setFormValues(value[0])
    }
  }, [others.visible])

  return (
    <Modal
      title='处方用法'
      {...others}
      width={720}
      onOk={() => {
        const useMethod = selectedValues?.filter((v) => v != '')?.join(',')
        localStorage.setItem('useMethod', useMethod)
        onChange && onChange(
          selectedValues, 
          selectedValues[0] == '制膏' || selectedValues[0] == '制丸' ? 
            {...form.getFieldsValue(), recipeNormalDose: ''} : form.getFieldsValue())
        if(selectedValues[0] == '制膏'){
          localStorage.setItem(
            'recipeTabletManufacturingNum',
            form.getFieldValue('recipeNormalFrequency')
          )
          localStorage.setItem(
            'recipePreparationPaste',
            form.getFieldValue('recipeNormalUsemethod')
          )
        } else if(selectedValues[0] == '制丸') {
          localStorage.setItem(
            'recipeTabletManufacturingNumZW',
            form.getFieldValue('recipeNormalFrequency')
          )
          localStorage.setItem(
            'recipePreparationPasteZW',
            form.getFieldValue('recipeNormalUsemethod')
          )
        } else {
          localStorage.setItem(
            'recipeNormalDose',
            form.getFieldValue('recipeNormalDose')
          )
          localStorage.setItem(
            'recipeNormalFrequency',
            form.getFieldValue('recipeNormalFrequency')
          )
          localStorage.setItem(
            'recipeNormalUsemethod',
            form.getFieldValue('recipeNormalUsemethod')
          )
        }
      }}
    >
      <Row {...row}>
        <Col {...col}>采用剂型：</Col>
        {K1.map((v, i) => (
          <Col key={v} {...col} offset={i === 5 ? 4 : undefined}>
            <div
              {...btn(v === selectedValues[0])}
              onClick={() => {
                setSelectedValues([
                  v,
                  ...selectedValues.slice(1).filter((v) => v != '无服用要求'),
                ])
                setFormValues(v)
              }}
            >
              {v}
            </div>
          </Col>
        ))}
      </Row>
      <Row {...row}>
        <Col {...col}>用药方法：</Col>
        {K2.map((v) => (
          <Col key={v} {...col}>
            <div
              {...btn(v === selectedValues[1])}
              onClick={() => {
                if (v == '外用') {
                  setFyyqDisplay('none')
                } else {
                  setFyyqDisplay('flex')
                }

                setSelectedValues([
                  selectedValues[0],
                  v,
                  ...selectedValues.slice(2).filter((v) => v != '无服用要求'),
                ])
              }}
            >
              {v}
            </div>
          </Col>
        ))}
      </Row>
      <Row
        {...row}
        style={{ display: fyyqDisplay }}
        className={styles.fyyqFirst}
      >
        <Col {...col}>服用要求：</Col>
        {K3.map((v) => (
          <Col key={v} {...col}>
            <div
              {...btn(v === selectedValues[2])}
              onClick={() => {
                setSelectedValues([
                  ...selectedValues.slice(0, 2),
                  v,
                  ...selectedValues.slice(3).filter((v) => v != '无服用要求'),
                ])
              }}
            >
              {v}
            </div>
          </Col>
        ))}
      </Row>
      <Row {...row} style={{ display: fyyqDisplay }} className={styles.fyyq}>
        {K4.map((v, i) => (
          <Col key={v} {...col} offset={i === 0 || i === 5 ? 4 : undefined}>
            <div
              {...btn(v === selectedValues[3])}
              onClick={() => {
                if (v == '无服用要求') {
                  setSelectedValues(['', '', '', v])
                } else {
                  setSelectedValues([...selectedValues.slice(0, 3), v])
                }
              }}
            >
              {v}
            </div>
          </Col>
        ))}
      </Row>
      <Form form={form}>
        <Row wrap={false} align='middle' {...row} style={{ height: '50px' }}>
          <Col {...col}>处方剂型：</Col>
          {selectedValues[0] == '制丸' ? (
            <Form.Item name='recipeNormalFrequency' noStyle>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
              >
                {RecipeTabletManufacturingCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipeTabletManufacturingName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : selectedValues[0] == '制膏' ? (
            <Form.Item name='recipeNormalFrequency' noStyle>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
              >
                {RecipePreparationPasteCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipePreparationPasteName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item name='recipeNormalFrequency' noStyle>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
              >
                {RecipeNormalFrequencyCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipeNormalFrequencyName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          )}
          {selectedValues[0] == '制丸' ? (
            <Form.Item name='recipeNormalUsemethod' noStyle>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
              >
                {RecipeTabletManufacturingNumCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipeTabletManufacturingNumName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : selectedValues[0] == '制膏' ? (
            <Form.Item name='recipeNormalUsemethod' noStyle>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
              >
                {RecipePreparationPasteNumCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipePreparationPasteNumName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item name='recipeNormalUsemethod' noStyle>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
              >
                {RecipeNormalUsemethodCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipeNormalUsemethodName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          )}
          {selectedValues[0] != '制丸' && selectedValues[0] != '制膏' ? (
            <Form.Item name='recipeNormalDose' noStyle style={{ flex: 1 }}>
              <Select
                placeholder='请选择'
                allowClear
                style={{ width: '300px', marginRight: '10px' }}
                // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
              >
                {RecipeNormalDoseCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {RecipeNormalDoseTypeName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : ''}
        </Row>
        <Row
          wrap={false}
          align='middle'
          {...row}
          style={{ height: '50px', marginBottom: '20px' }}
        >
          <Col {...col}>备注：</Col>
          <Form.Item label='' name='remark' {...firstColumnLayout} noStyle>
            <Input.TextArea
              maxLength={100}
              showCount
              style={{ width: '560px', marginTop: '32px' }}
            />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  )
}
